var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"s-tabs"}},[_c('b-row',{staticClass:"rc",attrs:{"align":"left"}},[_c('b-col',{attrs:{"cols":"12"}},_vm._l((_vm.tabList),function(btn){return _c('b-button',{key:btn.index,class:_vm.value==btn.id ? 'btnSelect' : 'btn',on:{"click":function($event){_vm._Value=btn.id}}},[_vm._v(" "+_vm._s(_vm.$t(btn.name))+" ")])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }